import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './utils/reportWebVitals';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Main from './main';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Main/>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
